import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import type { Entity } from '@backstage/catalog-model';
import { tabVisible } from '@platform/plugin-platform-react';

/**
 * L'onglet « Tâches planifiées », un onglet simple depuis l'abandon des groupes
 * d'onglets (2026-09-29) : sa position est fixée dans `app-config.yaml`.
 *
 * Dans l'ancien onglet, `CronjobManagerContent` était rendu SANS garde de
 * permission, contrairement aux cartes Kubernetes voisines. Ce comportement
 * est repris tel quel : son contenu gère ses propres droits.
 */
const isComponent = (entity: Entity): boolean =>
  entity.kind?.toLowerCase() === 'component';

const cronjobsContent = EntityContentBlueprint.make({
  name: 'cronjobs',
  params: {
    path: '/cronjobs',
    title: 'CronJobs',
    filter: tabVisible('cronjobs', isComponent),
    loader: () =>
      import('./CronjobManagerContent').then(m => <m.CronjobManagerContent />),
  },
});

export default createFrontendPlugin({
  pluginId: 'cronjobs',
  extensions: [cronjobsContent],
});
